/**
 * 설문 답변 상태
 * @enum {string}
 */
export const REQUEST_STATE = {
    /** 초기값 */
    NONE: 'NONE',
    /** 요청 중 */
    PENDING: 'PENDING',
    /** 요청 성공 */
    SUCCESS: 'SUCCESS',
    /** 요청 실패 */
    FAIL: 'FAIL'
};